import pageActions from '../page/actions';
import fieldActions from '../fields/actions';
import groupActions from '../groups/actions';

export default (state = {}, action) => {
  switch (action.type) {
    case pageActions.GO_SUCCESS:
    case groupActions.UPLOAD_SUCCESS:
    case fieldActions.RERENDER_SUCCESS:
      return action.payload.data.meta.progress || state;
    default:
      return state;
  }
};
